import { fetchPageData } from "../utils/fetch";

export const getContacts = async () => {
  const endpoint = "contacts";
  const method = "GET";
  const err = "Failed to fetch contacts.";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};

export const updateContact = async (token, contactId, contactData) => {
  const endpoint = contactId ? `contact/${contactId}` : "contact";
  const err = contactId
    ? "Editing contact failed."
    : "Creating contact failed.";
  const method = contactId ? "PUT" : "POST";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    token,
    contactData
  );
  return fetchedData;
};

export const deleteContact = async (token, contactId) => {
  const endpoint = `contact/${contactId}`;
  const method = "DELETE";
  const err = "Deleting contact failed.";
  const fetchedData = await fetchPageData(endpoint, method, err, token);
  return fetchedData;
};
